"use client";

import { useEffect, useState } from "react";

export default function ClientDate() {
  const [dateStr, setDateStr] = useState<string>("");
  const [timeStr, setTimeStr] = useState<string>("");

  useEffect(() => {
    const update = () => {
      const now = new Date();
      setDateStr(new Intl.DateTimeFormat('en-US', { 
        weekday: 'long', 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      }).format(now));
      
      setTimeStr(new Intl.DateTimeFormat('en-US', { 
        hour: 'numeric', 
        minute: 'numeric', 
        second: 'numeric', 
        hour12: true 
      }).format(now));
    };

    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!dateStr) return <div className="h-4 w-32 bg-muted animate-pulse rounded" />;

  return (
    <div className="flex flex-col items-start gap-0.5 leading-none">
      <span className="text-[10px] font-black uppercase tracking-widest text-foreground">{dateStr}</span>
      <span className="text-[10px] font-mono font-black text-brand uppercase">{timeStr}</span>
    </div>
  );
}
